export const PAYMENT_ACCOUNT_DETAILS = {
  accountName: 'Tchikamalor Global Nig. Ltd',
  bankName: 'Access Bank',
  accountNumber: '0036483685',
};

export const PAYMENT_GENERATION_STEPS = [
  'Preparing secure payment channel...',
  'Generating dedicated payment reference...',
  'Verifying bank route...',
  'Finalizing account instructions...',
];

export const CUSTOMER_CARE_WHATSAPP = '2348024980215';
